<template>
    <div>
        <el-dialog class="dialogDiv" :close-on-click-modal="false" :modal-append-to-body='false' :title="dialogTitle" :visible.sync="togSubDialogVisible" :before-close="handleCloseDialog">
            <div v-if="togSubData.areaCode" class="mt20">
                <el-input placeholder="主体名或许可备案号" class="w300 seekIpt" v-model="searchInput" @keyup.enter.native="search">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
                </el-input>
                <el-cascader class="ml20 w350" v-model="areaCode" :show-all-levels="false" :options="areaList.options" @change="areaChange" :props="areaList.props" clearable placeholder="所属行政区" ref="cascader"></el-cascader>
            </div>
            <div v-else>
                <el-input placeholder="主体名或许可备案号" class="w300 seekIpt" v-model="searchInput" @keyup.enter.native="search">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
                </el-input>
                <el-select class="ml20 w200" v-model="togSystem" :disabled="togSysDisabled" placeholder="请选择TOG系统" @change="togSystemChange">
                    <el-option v-for="item in togSystems" :key="item.appId" :label="item.title" :value="item.appId"></el-option>
                </el-select>
                <el-cascader class="ml20 w350" v-model="togAreaCode" :show-all-levels="false" :options="areaListFromSystem.options" @change="togAreaChange" :props="areaListFromSystem.props" placeholder="所属行政区" ref="togCascader"></el-cascader>
            </div>
            <div style="margin-top: 10px;">
                <el-table :data="tableData" highlight-current-row @current-change="handleCurrentChange" border :cell-style="{'text-align': 'center'}" :header-cell-style="{'text-align': 'center'}" v-loading="tableLoading">
                    <el-table-column label="序号" width="80" type=index >
                        <template slot-scope="scope">
                            {{(page.pageSize * (page.pageNum - 1) + scope.$index + 1)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="entityName" label="主体名" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.entityName ? scope.row.entityName: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="licence" label="许可备案号" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.licence ? scope.row.licence: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="entityTypeStr" label="行业类型" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.entityTypeStr ? scope.row.entityTypeStr: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="realityAddress" label="经营地址/场所地址" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.realityAddress ? scope.row.realityAddress: '-'}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <ybPagination :page="page" @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top:10px"></ybPagination>
            <div class="mt20" style="color: red;">提示：请先选择TOG系统，再选择所属行政区，然后再选择TOG主体进行绑定</div>
            <div class="footer" v-if="this.togSubData.type !== 'isDetail'">
                <el-button @click="cancle" round>取消</el-button>
                <el-button type="primary" @click="bind" round>绑定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as subManageApi from '@/api/subManage'
import ybPagination from '@/components/ybPagination'
export default {
    name: 'TogSubDialog',
    components: {
        ybPagination
    },
    data() {
        return {
            dialogTitle: '选择TOG主体',
            dialogVisible: false,
            searchInput: '',
            togSystem: '',
            togSystems: [],
            isTrueTree: true, // 是否成功返回区域树
            tableData: [],
            currentAreaCode: '',
            areaCode: [],
            areaList: {
                selectedOptions: [],
                options: [],
                parentAreaCode: '',
                props: {
                    checkStrictly: true,
                    expandTrigger: 'hover',
                    value: 'areaCode',
                    label: 'deptName',
                    children: 'children'
                }
            },
            togAreaCode: [],
            areaListFromSystem: {
                selectedOptions: [],
                options: [],
                props: {
                    checkStrictly: true,
                    expandTrigger: 'hover',
                    value: 'areaCode',
                    label: 'areaName',
                    children: 'children'
                }
            },
            tableLoading: false,
            page: {
                pageSize: 10,
                pageNum: 1,
                total: 0
            },
            bindParams: {},
            selectedRow: {}
        }
    },
    props: {
        togSubDialogVisible: {
            required: true,
            type: Boolean
        },
        togSubData: {
            type: Object,
            required: true
        }
    },
    computed: {
        togSysDisabled() {
            return this.togSystem && this.isTrueTree ? true : false
        },
        queryListParams(){
            return {
                entityId: this.togSubData.entityId,
                areaCode: typeof(this.areaCode) === 'string' ? this.areaCode : this.areaCode[this.areaCode.length - 1],
                current: this.page.pageNum,
                keyWord: this.searchInput,
                size: this.page.pageSize
            }
        }
    },
    methods: {
        search() {
            this.page.pageNum = 1;
            this.tableRefresh();
        },
        // 点击区域节点前的圆圈进行选择
        areaChange(val) {
            this.page.pageNum = 1;
            this.areaList.selectedOptions = val;
            this.tableRefresh();
        },
        // tog系统下拉列表
        getTogSystemList() {
          subManageApi.togSysList().then(res => {
            if(res.code === 200) {
              this.togSystems = res.data
            }
          }).catch(err => {})
        },
        // tog系统选择
        togSystemChange(val) {
          this.getTogAreaTree()
        },
        // 根据tog系统返回区域树
        getTogAreaTree() {
          if(!this.togSystem) {
            this.$message.warning('请先选择TOG系统')
          } else {
            subManageApi.togAreaTree({appId: this.togSystem}).then(res => {
              if(res.code === 200) {
                this.isTrueTree = true
                this.areaListFromSystem.options = res.data.children
              } else {
                this.isTrueTree = false
              }
              // else {
              //   let obj = {}
              //   obj.stopPropagation = () =>{}
              //   try{
              //     this.$refs.togCascader.clearValue(obj)
              //   }catch(err){
              //     this.$refs.togCascader.handleClear(obj)
              //   }
              //   // TODO bug
              //   this.areaListFromSystem.options = []
              // }
            }).catch(err => {})
          }
        },
        // tog区域树选择
        togAreaChange(val) {
          this.getTogToBindSubList()
        },
        // 根据tog系统返回tog主体列表
        getTogToBindSubList() {
          let params = {
            keyword: this.searchInput,
            appId: this.togSystem,
            areaCode: this.togAreaCode[this.togAreaCode.length - 1],
            pageNum: this.page.pageNum,
            pageSize: this.page.pageSize
          }
          this.tableLoading = true
          subManageApi.togToBindSubList(params).then(res => {
            if(res.code === 200) {
              this.tableData = res.data.list
              this.page.total = res.data.total
            }
            this.tableLoading = false
          }).catch(err => {})
        },
        // tog区域列表
        async togAreaList() {
            await subManageApi.togAreaList({areaCode: this.togSubData.areaCode, entityId: this.togSubData.entityId}).then(r => {
                if (r.status === true) {
                    this.currentAreaCode = r.data.currentAreaCode;
                    this.getCurrentArea([r.data.deptTree]);
                    // 去掉最后一级空白页
                    this.areaList.options = this.getTreeData([r.data.deptTree]);
                    // 遍历后未找到对应的areaCode, 则回显第一级区域
                    if(this.areaCode !== this.currentAreaCode) {
                        this.$message.warning('未找到对应的TOG主体, 将展示所有TOG主体')
                        this.areaCode = r.data.deptTree.areaCode
                    }
                }
            }).catch(e=>{});
            this.tableRefresh();
        },
        // 区域回显
        getCurrentArea(data) {
            data.forEach(el => {
                if(el.areaCode === this.currentAreaCode) {
                    this.areaCode = this.currentAreaCode;
                } else {
                    this.getCurrentArea(el.children)
                }
            })
            
        },
        // 递归判断列表，把最后的children设为undefined, 去除最后一页空白
        getTreeData(data){
            data.forEach(el => {
                if(el.children.length<1) {
                    // children若为空数组，则将children设为undefined
                    el.children = undefined
                } else {
                    // children若不为空数组，则继续 递归调用 本方法
                    this.getTreeData(el.children)
                }
            });
            return data;
        },
        // 列表行选中
        handleCurrentChange(row) {
            this.bindParams = {}
            if(!row) return
            if(!this.togSubData.areaCode) {
              this.selectedRow = row
              return
            }
            this.bindParams.entityId = this.togSubData.entityId
            this.bindParams.togEntityType = row.entityType
            this.bindParams.togId = row.id
            this.bindParams.togLicense = row.licence
            this.bindParams.togName = row.entityName
            this.bindParams.togCreditCode = row.creditCode
            this.bindParams.togAreaCode = row.areaCode
        },
        tableRefresh() {
            if(!this.togSubData.areaCode) {
              this.getTogToBindSubList()
              return
            }
            this.tableLoading = true
            subManageApi.togSubList(this.queryListParams).then(r => {
                if(r.status === true) {
                    this.tableData = r.data.list
                    this.page.total = parseInt(r.data.total)
                }
                this.tableLoading = false;
            }).catch(err => {})
        },
        // 页数改变
        pageCurrentChange(num) {
            if(num !== this.page.pageNum) {
                this.page.pageNum = num;
                this.tableRefresh();
            }
        },
        // 页数据量改变
        pageSizeChange(size) {
            this.page.pageNum = 1
            if(size !== this.page.pageSize) {
                this.page.pageSize = size;
                this.tableRefresh();
            }
        },
        bind() {
            if(!this.bindParams) {
                this.$message.warning('请点击列表,选择对应的主体后再绑定')
            } else {
                if(this.bindParams.togEntityType !== 'RESTAURANT' && this.selectedRow.entityType !== 'RESTAURANT' && this.bindParams.togEntityType !== 'PRODUCT' && this.selectedRow.entityType !== 'PRODUCT') {
                    this.$message.warning('仅能绑定餐饮主体或生产主体')
                } else {
                  if(this.$parent.subjectAdd) {
                      this.$confirm('绑定会覆盖已经填写的部分内容, 是否确定?', '提示', {
                          confirmButtonText: '确定',
                          cancelButtonText: '取消',
                          type: 'warning',
                          closeOnClickModal: false,
                          distinguishCancelAndClose: true
                      }).then(() => {
                          this.bindTog()
                      }).catch(e => {
                          // 关闭弹框
                          if(e === 'close') return 
                          // 不同步
                          this.$parent.togSubDialogVisible = false
                      })
                    } else {
                      this.bindTog()
                    }
                }
            }
        },
        bindTog() {
          if(!this.togSubData.areaCode) { // 主体添加-绑定TOGID
              this.$confirm('是否从TOG主体同步待添加字段？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  closeOnClickModal: false,
                  distinguishCancelAndClose: true,
                  type: 'warning'
              }).then(() => {
                  this.selectedRow.togSystemName = this.togSystem
                  this.selectedRow.togAreaCode = this.selectedRow.areaCode
                  this.$emit('getTogData', this.selectedRow)
                  this.$emit('isTogSync', true)
                  this.handleCloseDialog();
              }).catch(e => {
                  this.$emit('getTogData', {id: this.selectedRow.id, 
                                            entityName: this.selectedRow.entityName, 
                                            togSystemName: this.togSystem,
                                            togAreaCode: this.selectedRow.areaCode})
                  this.$emit('isTogSync', false)
                  this.handleCloseDialog();
              })
          } else {
            subManageApi.togSubBind(this.bindParams).then(r=>{
                if(r.code === 200) {
                    this.$message.success('绑定成功!')
                    this.$parent.tableRefresh();
                    this.handleCloseDialog();
                }
            }).catch(e=>{})
        }
        },
        cancle() {
            this.handleCloseDialog();
        },
        handleCloseDialog() {
            this.$emit('closeTogSubDialog');
        }
    },
    created() {
      if(this.togSubData.areaCode) { // 从同步绑定打开
        this.togAreaList();
      } else { // 从主体管理-添加-TOGID绑定打开
        this.getTogSystemList()
      }
    }
}
</script>

<style lang="scss" scoped>
    .dialogDiv {
      text-align: left;
    }
    .dialogDiv::v-deep .el-dialog{
      width: 1000px;
    }
    .footer {
      margin-top: 20px;
      text-align: right;
    }
</style>